export type CurrencyCode = 'GNF' | 'XOF' | 'XAF' | 'USD' | 'EUR' | 'NGN' | 'GHS' | 'KES' | 'ZAR';

export interface CurrencyConfig {
  code: CurrencyCode;
  label: string;
  symbol: string;
  locale: string;
  decimals: number;
}

export const CURRENCIES: Record<CurrencyCode, CurrencyConfig> = {
  GNF: { code: 'GNF', label: 'Franc guinéen', symbol: 'GNF', locale: 'fr-GN', decimals: 0 },
  XOF: { code: 'XOF', label: 'Franc CFA (UEMOA)', symbol: 'FCFA', locale: 'fr-SN', decimals: 0 },
  XAF: { code: 'XAF', label: 'Franc CFA (CEMAC)', symbol: 'FCFA', locale: 'fr-CM', decimals: 0 },
  USD: { code: 'USD', label: 'Dollar US', symbol: '$', locale: 'en-US', decimals: 2 },
  EUR: { code: 'EUR', label: 'Euro', symbol: '€', locale: 'fr-FR', decimals: 2 },
  NGN: { code: 'NGN', label: 'Naira nigérian', symbol: '₦', locale: 'en-NG', decimals: 2 },
  GHS: { code: 'GHS', label: 'Cedi ghanéen', symbol: 'GH₵', locale: 'en-GH', decimals: 2 },
  KES: { code: 'KES', label: 'Shilling kenyan', symbol: 'KSh', locale: 'en-KE', decimals: 2 },
  ZAR: { code: 'ZAR', label: 'Rand sud-africain', symbol: 'R', locale: 'en-ZA', decimals: 2 },
};

export const DEFAULT_CURRENCY: CurrencyCode = 'GNF';

export const CURRENCY_LIST = Object.values(CURRENCIES);
